import {Component} from "react";
import banner from "../../media/banner.jpg"
import "./Index.css"
import tapas from "../../media/TapasTacones.png"
import suelas from "../../media/Servicios/Suelas.png"
import costuras from "../../media/Servicios/Costuras.png"
import pintura from "../../media/Servicios/Boleado.png"
import hormado from "../../media/Servicios/Hormado.png"
import plantillas from "../../media/Servicios/plantillas.jpg"
import aumentos from "../../media/Servicios/aumentos.jpg"
import taloneras from "../../media/Servicios/taloneras.png"
import ContactForm from "../ContactForm/ContactForm";

export class Index extends Component {
    render() {
        return (
            <div className={"index"}>
                <div className="carrousel">
                    <img src={banner} alt=""/>
                </div>
                <div className="nosotros">
                    <h2>Nosotros</h2>
                    <div className="text">
                        Somos un equipo de personas apasionadas cuyo objetivo es mejorar la vida de sus pies y calzado a través de productos y servicios especializados.
                    </div>
                </div>
                <div className="servicios">
                    <h2>Servicios</h2>
                    <div className="cursiva">
                        <h2>Reparación</h2>
                    </div>
                    <div className="items">
                        <a href="/servicios?target=tapas" className="item">
                            <img src={tapas} alt=""/>
                            <p>Tapas y Tacones</p>
                        </a>
                        <a href="/servicios?target=suelas" className="item">
                            <img src={suelas} alt=""/>
                            <p>Suelas</p>
                        </a>
                        <a href="/servicios?target=costuras" className="item">
                            <img src={costuras} alt=""/>
                            <p>Costuras y detalles</p>
                        </a>
                        <a href="/servicios?target=pintura" className="item">
                            <img src={pintura} alt=""/>
                            <p>Pintura lavado y boleado</p>
                        </a>
                        <a href="/servicios?target=hormado" className="item">
                            <img src={hormado} alt=""/>
                            <p>Hormado</p>
                        </a>
                    </div>
                    <div className="cursiva">
                        <h2>Ortopedia</h2>
                    </div>
                    <div className="items">
                        <a href="/servicios?target=plantillas" className="item">
                            <img src={plantillas} alt=""/>
                            <p>Plantillas <br/>Ortopédicas</p>
                        </a>
                        <a href="/servicios?target=aumentos" className="item">
                            <img src={aumentos} alt=""/>
                            <p>Aumentos compensatorios <br/>a la medida</p>
                        </a>
                        <a href="/servicios?target=taloneras" className="item">
                            <img src={taloneras} alt=""/>
                            <p>Taloneras niveladoras br a la medida</p>
                        </a>
                    </div>
                    <div className="buttons">
                        <a href="/todos-los-servicios" className="blue-button">Ver lista de servicios completa</a>
                    </div>

                    {<ContactForm/>}
                </div>
            </div>
        )
    }
}